import affiliatesActions from './affiliates';
import profile from './profile';
import postBack from './postback';
import * as deploy from './deploy';

/**
 * TODO
 * functions must be closed "Action" with word
 */
export default {
  ...affiliatesActions,
  ...profile,
  ...postBack,
  ...deploy,
};
